<template>
  <div class="app-page">
    <PageHeader type="back" :title="formData.id == 'new' ? 'Add New Employee' : 'Edit Employee'" />
    <div class="application-page-container">
      <a-form layout="vertical" ref="form" :model="formData" @finish="formFinish" :rules="validateRules">
        <section>
          <h2 class="section-title">{{ $t('admin.Employee') }}</h2>
          <a-form-item :label="$t('admin.Employee LLID')" name="a_LLID">
            <a-input v-model:value="formData.a_LLID" :placeholder="$t('admin.Please Input')"
              :disabled="formData.id != 'new'"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Employee CS ID')" name="a_LLID">
            <a-input v-model:value="formData.cs_id" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Employee English Name')" name="a_Name">
            <a-input v-model:value="formData.a_Name" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Employee Email Address')" name="a_Email">
            <a-input v-model:value="formData.a_Email" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Employee Title')" name="a_Title">
            <a-input v-model:value="formData.a_Title" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Level1')" name="a_Brand">
            <a-input v-model:value="formData.a_Brand" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.SubLevel')" name="a_SubLevel">
            <a-input v-model:value="formData.a_SubLevel" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Level2')" name="a_Role">
            <a-input v-model:value="formData.a_Role" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Level3')" name="a_Level">
            <a-input v-model:value="formData.a_Level" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Job Grading')" name="a_Grading">
            <a-select ref="select" v-model:value="formData.a_Grading" :placeholder="$t('admin.Please Select')">
              <a-select-option v-for="grading in ['O', 'P', 'Q', 'R', 'S']" :key="grading" :value="grading">
                {{ grading }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('admin.Location of Employee')" name="a_Location">
            <a-select ref="select" v-model:value="formData.a_Location" :placeholder="$t('admin.Please Select')">
              <a-select-option v-for="location in ['Beijing', 'Shanghai', 'Guangzhou']" :key="location" :value="location">
                {{ location }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('admin.HFM Code')" name="HFMCode">
            <a-input v-model:value="formData.HFMCode" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Department/Client')" name="departmentClient">
            <a-input v-model:value="formData.departmentClient" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Parent Function')" name="parentFunction">
            <a-input v-model:value="formData.parentFunction" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Child Function')" name="childFunction">
            <a-input v-model:value="formData.childFunction" :placeholder="$t('admin.Please Input')"></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Join Date')" name="joinDate">
            <a-date-picker v-model:value="formData.joinDate" :placeholder="$t('admin.Please Input')" />
          </a-form-item>
        </section>
        <section>
          <h2 class="section-title">{{ $t('admin.Review Manager') }}</h2>
          <a-row>
            <a-form-item :label="$t('admin.LLID of Review Manager')" name="b_LLID">
              <a-input v-model:value="formData.b_LLID" :placeholder="$t('admin.Please Input')"
                :disabled="formData.id != 'new'" @blur="loadReviewManager"></a-input>
            </a-form-item>
            <span class="loading-small" v-if="loadingLM">loading...</span>
            <span class="loading-small error-small" v-if="wrongLM">
              {{
                isEn
                ? 'Please enter the correct manager LionID'
                : '请输入正确的狮厂经理 LionID'
              }}
            </span>
          </a-row>
          <a-form-item :label="$t('admin.Review Manager Name(EN)')" name="b_Name">
            <a-input v-model:value="formData.b_Name" :placeholder="$t('admin.Please Input')" disabled></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Review Manager Email Address')" name="b_Email">
            <a-input v-model:value="formData.b_Email" :placeholder="$t('admin.Please Input')" disabled></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Review Manager Title')" name="b_Title">
            <a-input v-model:value="formData.b_Title" :placeholder="$t('admin.Please Input')" disabled></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.Brand of Review Manager')" name="b_Brand">
            <a-input v-model:value="formData.b_Brand" :placeholder="$t('admin.Please Input')" disabled></a-input>
          </a-form-item>
        </section>
        <section>
          <h2 class="section-title">{{ $t('admin.HRBP') }}</h2>
          <a-row>
            <a-form-item :label="$t('admin.LLID of HRBP')" name="c_LLID">
              <a-input v-model:value="formData.c_LLID" :placeholder="$t('admin.Please Input')"
                :disabled="formData.id != 'new'" @blur="loadHRBP"></a-input>
            </a-form-item>
            <span class="loading-small" v-if="loadingHRBP">loading...</span>
            <span class="loading-small error-small" v-if="wrongHRBP">
              {{
                isEn
                ? 'Please enter the correct HRBP LionID'
                : '请输入正确的HRBP LionID'
              }}
            </span>
          </a-row>
          <a-form-item :label="$t('admin.HRBP Name (EN)')" name="c_Name">
            <a-input v-model:value="formData.c_Name" :placeholder="$t('admin.Please Input')" disabled></a-input>
          </a-form-item>
          <a-form-item :label="$t('admin.HRBP Email Address')" name="c_Email">
            <a-input v-model:value="formData.c_Email" :placeholder="$t('admin.Please Input')" disabled></a-input>
          </a-form-item>
        </section>

        <a-form-item class="form-btn-groups">
          <a-popconfirm :title="$t('admin.If you leave before saving, your changes will be lost')
            " v-if="dirty" @confirm="$router.back" :okText="$t('admin.OK')" :cancelText="$t('admin.Cancel')">
            <a-button class="btn-back">{{ $t('admin.Back') }}</a-button>
          </a-popconfirm>
          <a-button class="btn-back" @click="$router.back" v-else>
            {{ $t('admin.Back') }}
          </a-button>

          <a-button type="primary" html-type="submit" :loading="loading">
            {{ formData.id == 'new' ? $t('admin.Add') : $t('admin.Save') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/PageHeader.vue'
import {
  getEmployeeDetail,
  addEmployee,
  updateEmployee,
  getOptionListByType,
  getManagerInfo,
} from '@/api/admin'
import { message } from 'ant-design-vue'
import { toRaw } from '@vue/reactivity'
import dayjs from 'dayjs'
import { getHRBPInfo } from '../../../api/admin'
import i18n from '@/locales'

export default {
  name: 'Index',
  components: {
    PageHeader,
  },
  data() {
    const validateRules = {}
    const inputFileds = [
      'a_LLID',
      'a_Name',
      'a_Title',
      'a_Location',
      // 'b_Name',
      // 'b_Title',
      'a_Brand',
      'a_SubLevel',
      'a_Role',
      'b_LLID',
      // 'c_Name',
      'c_LLID',
      'HFMCode',
      'departmentClient',
      'parentFunction',
      'childFunction',
    ]
    const dateFileds = ['joinDate']
    dateFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          validator: (_rule, value) => {
            if (value == null || !value.isValid()) {
              return Promise.reject(this.$t('admin.Please Input'))
            } else {
              return Promise.resolve()
            }
          },
          trigger: 'change',
        },
      ]
    })
    // const selectFileds = ['a_Grading', 'b_Brand']
    const selectFileds = ['a_Grading']
    // const emailFields = ['a_Email', 'b_Email', 'c_Email']
    const emailFields = ['a_Email']
    emailFields.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Input'),
          trigger: 'blur',
        },
        {
          pattern:
            /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: this.$t('admin.Incorrect mailbox format'),
        },
      ]
    })
    inputFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Input'),
          trigger: 'blur',
        },
      ]
    })
    selectFileds.map((item) => {
      validateRules[item] = [
        {
          required: true,
          message: this.$t('admin.Please Select'),
          trigger: 'blur',
        },
      ]
    })
    return {
      loading: false,
      formData: {},
      validateRules,
      eId: null,
      dirty: false,
      popoverVisible: false,
      selectOptions: {},
      loadingLM: false,
      loadingHRBP: false,
      wrongLM: false,
      wrongHRBP: false,
    }
  },
  watch: {
    formData: {
      handler: function (n, o) {
        this.dirty = true
      },
      deep: true,
    },
  },
  computed: {
    dataAllReady() {
      return false
    },
    isEn() {
      return i18n.global.locale == 'en-US'
    },
  },
  created() {
    const eid = this.$route.params.id
    if (eid) {
      this.formData.id = eid
      this.eId = eid
    }
    this.initSelectOptions()
    if (eid != 'new') {
      getEmployeeDetail(eid).then((res) => {
        if (res.code == 200) {
          const {
            employee,
            cs_id,
            lm,
            hrbp,
            hfmcode,
            department,
            parent_function,
            child_function,
          } = res.data
          const join_date_dayjs = dayjs(res.data.join_date).isValid()
            ? dayjs(res.data.join_date)
            : null

          this.formData = {
            cs_id,
            a_LLID: employee.lion_id,
            a_Name: employee.name,
            a_Email: employee.email,
            a_Title: employee.title,
            a_Brand: employee.brand,
            a_SubLevel: employee.sublevel,
            a_Role: employee.role,
            a_Level: employee.level,
            a_Grading: employee.grading,
            a_Location: employee.location,
            b_Name: lm.name,
            b_LLID: lm.lion_id,
            b_Brand: lm.brand,
            b_Title: lm.title,
            b_Email: lm.email,
            c_Name: hrbp.name,
            c_LLID: hrbp.lion_id,
            c_Email: hrbp.email,
            HFMCode: hfmcode,
            departmentClient: department,
            parentFunction: parent_function,
            childFunction: child_function,
            joinDate: join_date_dayjs,
          }
          let that = this
          setTimeout(() => {
            that.dirty = false
          }, 50)
        }
      })
    } else {
      setTimeout(() => {
        this.dirty = false
      }, 50)
    }
  },
  methods: {
    initSelectOptions() {
      const list = ['brand', 'role', 'level']
      for (var key of list) {
        const kv = key
        getOptionListByType(key).then((res) => {
          if (res.code === 200) {
            this.selectOptions[kv] = res.data
          }
        })
      }
    },

    async loadReviewManager() {
      this.loadingLM = true
      this.wrongLM = false
      try {
        const res = await getManagerInfo(this.formData.b_LLID)
        if (res.data == null) {
          this.formData = {
            ...this.formData,
            b_Name: '',
            b_Brand: '',
            b_Title: '',
            b_Email: '',
          }
          this.wrongLM = true
        } else {
          this.formData = {
            ...this.formData,
            b_Name: res.data.name,
            b_Brand: res.data.brand,
            b_Title: res.data.title,
            b_Email: res.data.email,
          }
          this.wrongLM = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingLM = false
      }
    },
    async loadHRBP() {
      this.loadingHRBP = true
      this.wrongHRBP = false
      try {
        const res = await getHRBPInfo(this.formData.c_LLID)

        if (res.data == null) {
          // message.error(
          //   this.isEn
          //     ? 'Please enter the correct HRBP LionID'
          //     : '请输入正确的HRBP LionID'
          // )
          this.formData = {
            ...this.formData,
            c_Name: '',
            c_Email: '',
          }
          this.wrongHRBP = true
        } else {
          this.formData = {
            ...this.formData,
            c_Name: res.data.name,
            c_Email: res.data.email,
          }
          this.wrongHRBP = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingHRBP = false
      }
    },

    formFinish() {
      this.loading = true
      const data = toRaw(this.formData)
      data.joinDate = dayjs(data.joinDate).format('YYYY-MM-DD')
      if (data.id === 'new') {
        addEmployee(data)
          .then(
            (res) => {
              this.$router.push({
                path: '/master/database/employee',
              })
              // message.success('You have successfully added a new employee')
              if (this.isEn) {
                message.success(
                  `You have successfully added ${this.formData.a_Name}`
                )
              } else {
                message.success(`${this.formData.a_Name}添加成功`)
              }
            },
            (err) => {
              if (err.code == '300301') {
                if (this.isEn) {
                  message.error(`Failed to add ${this.formData.a_Name}`)
                } else {
                  message.error(`${this.formData.a_Name}添加失败`)
                }
              } else {
                message.error(`Error Code:${err.code}`)
              }
            }
          )
          .finally(() => {
            this.loading = false
          })
      } else {
        let that = this
        updateEmployee(this.eId, data)
          .then(
            (res) => {
              // message.success(
              //   'You have successfully updated employee information.'
              // )
              if (this.isEn) {
                message.success(
                  `You have successfully updated ${this.formData.a_Name} information.`
                )
              } else {
                message.success(`${this.formData.a_Name}更新成功`)
              }
              that.$router.push({ path: '/master/permission/employee' })
            },
            (err) => {
              if (err.code == '300301') {
                if (this.isEn) {
                  message.error(`Failed to update ${this.formData.a_Name}`)
                } else {
                  message.error(`${this.formData.a_Name}更新失败`)
                }
              } else {
                message.error(`Error Code:${err.code}`)
              }
            }
          )
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  font-weight: 700;
}

.loading-small {
  margin-top: 35px;
}

.error-small {
  color: red;
}

@import url('@/styles/params.less');

.application-page-container {
  margin: @app-conetent-margin;
  background-color: white;
  padding: 24px;
}

.ant-form-vertical .ant-form-item {
  display: inline-block;
  width: 230px;
  margin-right: 70px;
}

.form-btn-groups {
  width: 100% !important;

  .ant-btn {
    width: 88px;
    margin-right: 16px;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1440px) {
  .ant-form-item:nth-child(3n + 3) {
    margin-right: 0;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1640px) {
  .ant-form-item:nth-child(4n + 4) {
    margin-right: 0;
  }
}
</style>
